import { render, staticRenderFns } from "./SoundIcon.vue?vue&type=template&id=253d4e4e&scoped=true&"
import script from "./SoundIcon.vue?vue&type=script&lang=js&"
export * from "./SoundIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253d4e4e",
  null
  
)

export default component.exports